import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {FormattedProperty} from 'common/util/format-property';
import {UnformattedUserEvent} from 'common/report/util/profile/types';
import {InspectorEvent} from 'common/report/queries/query-api/inspector';

export const DATE_FORMAT_STRING = `YYYY-MM-DD`;
export const DISPLAY_DATE_FORMAT_STRING = `MMMM Do, YYYY`;
export const SINCE_DATE_FORMAT_STRING = `MMMM Do, h:mm a`;
export const NUM_PREVIEW_PROPERTIES = 5;
export const INITIAL_NUM_EVENTS_LIMIT = 100;
export const DEFAULT_NUMBER_OF_EVENTS_TO_DISPLAY = 100;
export const EVENT_DISPLAY_SIZE_INCREMENT = 100;

export interface ProfileActivityState {
  // These fields are URLFilter fields:
  excludedEvents: string[]; // list of raw unformatted event names
  includedEvents: string[]; // list of raw unformatted event names
  dateRange: DateRange;

  // Other normal state fields
  sentinelEvent: InspectorEvent;
  enableShowMoreButton: boolean;
  error: boolean;
  loading: {
    initial: boolean;
    eventDefinitions: boolean;
    moreEvents: boolean;
    propertyDefinitions: boolean;
  };
  rawEvents: UnformattedUserEvent[]; // used to keep track of all user events when merging queries and subsequent requests
  renderedGroupings: Map<string, boolean>;
}

// Any of these may be in the url filters, but not guaranteed
export type ProfileActivityURLState = Partial<
  Pick<ProfileActivityState, 'excludedEvents' | 'includedEvents' | 'dateRange'>
>;

export interface FormattedUserEvent {
  eventDisplayName: string;
  insertId: string;
  recordingId?: string;
  mixpanelProperties: FormattedProperty[];
  userDefinedEventProperties: FormattedProperty[];
  time: number;
}

export interface ActivityGroup {
  eventName: string;
  eventGroup: FormattedUserEvent[];
}

export interface ActivityDayGroup {
  dayHeader: string;
  activities: ActivityGroup[];
}

export interface ProfileActivityAttrs {
  'data-group-id'?: string | number;
  'distinct-id': string;
  'history-limit-days': number;
  'sidebar-mode'?: boolean;
  'utc-offset': number;
  timezone: string;
  'from-date'?: string;
  'to-date'?: string;
  'profile-email': string;
  'project-as-of-date': string;
}
